import styles from './Breadcrumb.module.scss';
import { type To, Link } from 'react-router';
import { useTexts } from 'components/texts';

type Props = {
  items?: { label: string; to?: To }[];
};

const Breadcrumb = ({ items }: Props) => {
  const T = useTexts();

  return (
    <ol className={styles.breadcrumb}>
      <li><Link to="/">{T.Breadcrumb_Home}</Link></li>
      {items?.map(item => (
        <li key={item.label}>
          {item.to ? <Link to={item.to}>{item.label}</Link> : <span>{item.label}</span>}
        </li>
      ))}
    </ol>
  );
};

export default Breadcrumb;
